const setTitle = title => {
  if (window.ChunyuNativeBridge && window.ChunyuNativeBridge.invoke) {
    window.ChunyuNativeBridge.invoke('1.0', 'setTitle', title);
  }
};

const jumpHistoryService = () => {
  window.location.href = 'chunyu://launch/history_service/?service_type=mall';
};

const setBackBtn = () => {
  if (window.ChunyuNativeBridge && window.ChunyuNativeBridge.invoke) {
    window.ChunyuNativeBridge.invoke(
      '1.0',
      'setBackBtn',
      JSON.stringify({
        do_close: 'true',
      })
    );
  }
};

// 分享
const shareCy = opt => {
  if (window.ChunyuNativeBridge && window.ChunyuNativeBridge.invoke) {
    const defaultOpt = {
      btn_visible: true, // 右上角分享按钮的可见性
      do_share: false, // 立即弹出分享菜单
      share_to: [
        'weixin_pengyouquan',
        'weixin_haoyou',
        'weibo',
        'qq',
        'qq_haoyou',
      ], // 分享到
      title: window.document.title, // 标题
      desc: '', // 描述
      link: window.location.href, // 链接
      img:
        '//static.chunyuyisheng.com/@/media/images/2016/03/29/61ad355d8b47_w180_h180_.jpg', // 缩略图
      ...opt,
    };

    window.ChunyuNativeBridge.invoke(
      '1.0',
      'share',
      JSON.stringify({
        ...defaultOpt,
        ...opt,
      })
    );
  }
};

// 沉浸式webview
const changeStatusBarColor = data => {
  if (window.ChunyuNativeBridge && window.ChunyuNativeBridge.invoke) {
    window.ChunyuNativeBridge.invoke(
      '1.0',
      'changeStatusBarColor',
      JSON.stringify(data)
    );
  }
};

const removeTip = data => {
  if (window.ChunyuNativeBridge && window.ChunyuNativeBridge.invoke) {
    window.ChunyuNativeBridge.invoke(
      '1.0',
      'remove_glabal_tip',
      JSON.stringify(data)
    );
  }
};

export default {
  jumpHistoryService,
  setTitle,
  shareCy,
  setBackBtn,
  changeStatusBarColor,
  removeTip,
};
